import { MprcRequestErrorDialog, MprcRequestIndicator } from "components";
import { AssessmentInstanceDto, AssessmentPlayerMode, AssessmentQuestionDto, AssessmentSaveResultDto, AssessmentStartPlayerDto, ChallengeMode } from "generated/CoreApi_v1";
import moment from "moment";
import { useSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AssPlayerBase } from "views/assessment/player/AssPlayerBase";

/////////////////////////////////////////////////////////////////////////////////

interface IPros {
  topicId: string;
  challengeMode: ChallengeMode;
  instanceId?: string;
  onClose: (success: boolean) => void;
}

export const AssPlayerChallenge: React.FC<IPros> = (props) => {
  const { topicId: assessmentId, instanceId, challengeMode, onClose } = props;

  const api = useCoreApi();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation("assessment");

  const [loading, setLoading] = useState<boolean>(true);
  const [viewError, setViewError] = useState<any>();
  const [startPlayer, setStartPlayer] = useState<AssessmentStartPlayerDto>();

  useEffect(() => {
    async function getData() {
      try {
        if (instanceId || instanceId != null) {
          setStartPlayer({
            deployId: null,
            startDate: moment().toDate(),
            endDate: moment().toDate(),
            playerMode: AssessmentPlayerMode.Resume,
            instanceId: instanceId!,
            participantId: null,
            message: null
          });
        } else {
          api.v1.assPlayer.createChallengeInstance({
            assessmentId: assessmentId!,
            challengeMode,
            preview: false
          })
            .then(result => {
              setStartPlayer({
                deployId: null,
                startDate: moment().toDate(),
                endDate: moment().toDate(),
                playerMode: AssessmentPlayerMode.Resume,
                instanceId: result.data.instanceId,
                participantId: null,
                message: null
              });
            })
            .catch(e => setViewError(e));
        }
      } catch (e) {
        setViewError(e);
      } finally {
        setLoading(false);
      }
    }
    if (loading) getData();

  }, [loading]);

  ////////////////////////////////////////////////////////////////////////////
  /// RENDER
  ////////////////////////////////////////////////////////////////////////////

  if (!loading && startPlayer && startPlayer.playerMode == AssessmentPlayerMode.NoAccess) {
    enqueueSnackbar(startPlayer.message ?? t("AssPlayer.Survey.CannotAccessMessage"), { variant: "error" });
    return null;
  }

  return (
    <>
      <MprcRequestErrorDialog error={viewError} onClose={() => onClose(false)} />

      <MprcRequestIndicator type="request" visible={loading} />

      {
        !loading && startPlayer &&
        <AssPlayerBase
          instanceId={startPlayer.instanceId}
          startPlayerMode={startPlayer.playerMode}
          createInstance={() =>
            new Promise<AssessmentInstanceDto>((resolve, reject) => {
              api.v1.assPlayer.createChallengeInstance({
                assessmentId: assessmentId!,
                challengeMode,
                preview: false
              })
                .then(result => resolve(result.data))
                .catch(e => reject(e));
            })
          }
          startInstance={(instanceId) =>
            new Promise<AssessmentSaveResultDto>((resolve, reject) => {
              throw new Error('Instance for challenge cannot start!');
            })
          }
          getStartPlayer={(playerMode, instanceId) => {
            if (instanceId) {
              return new Promise<AssessmentInstanceDto>((resolve, reject) => {
                api.v1.assPlayer.getChallengeInstance({ instanceId })
                  .then(result => resolve(result.data))
                  .catch(e => reject(e));
              });
            } else {
              throw new Error('Instance is required!');
            }
          }}
          getQuestion={(action, playerMode, instanceId, questionIdRef, versionRef) => {
            if (instanceId) {
              return new Promise<AssessmentQuestionDto>((resolve, reject) => {
                api.v1.assPlayer.getQuestionAssInstance({
                  instanceId: instanceId,
                  questionIdRef: questionIdRef ?? null,
                  versionRef: versionRef ?? null,
                  playerMode,
                  action
                })
                  .then(result => resolve(result.data))
                  .catch(e => reject(e));
              });
            } else {
              throw new Error('Instance is required!');
            }
          }}
          onClose={onClose}
        />
      }
    </>
  );
};
